import React from "react";

import ReactMarkdown, { Options } from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";

import { cn } from "@/utils/cn";

import "./Markdown.css";

interface IMarkdown extends Readonly<Options> {
	className?: string;
}

/**
 * Task notes in Markdown (GFM tables, highlighted code blocks). HTML typed
 * in the text is shown as text, never interpreted: the notes of a task are
 * read by everyone it is shared with, and rehype-raw let an
 * `<iframe srcdoc>` run a script with the page's rights, a `<style>` restyle
 * the whole app, a `<form>` pose as a login. Code blocks never needed it.
 */
export const Markdown: React.FC<IMarkdown> = ({
	children,
	className = "",
	...props
}) => {
	return (
		<div className={cn(["markdown", className])}>
			<ReactMarkdown
				remarkPlugins={[remarkGfm]}
				rehypePlugins={[rehypeHighlight]}
				{...props}
				components={{
					// `node` is react-markdown's syntax-tree node: spread as-is it
					// landed in the DOM as node="[object Object]".
					a: ({ node: _node, ...tagProps }) => (
						<a
							{...tagProps}
							target="_blank"
							rel="noopener noreferrer"
						/>
					),
					...props.components,
				}}
			>
				{children}
			</ReactMarkdown>
		</div>
	);
};
